import React, { useState } from 'react';
import './Careers.css';

const Careers = () => {
  const [formData, setFormData] = useState({
    fullName: '',
    email: '',
    phoneNumber: '',
    message: ''
  });

  const [step, setStep] = useState(1);

  const handleSubmit = (e) => {
    e.preventDefault();
    if (step === 1) {
      setStep(2);
      window.scrollTo(0, 0);
      return;
    }
    
    const subject = encodeURIComponent('Job Application');
    const body = encodeURIComponent(`
Full Name: ${formData.fullName}
Email: ${formData.email}
Phone Number: ${formData.phoneNumber}
Message: ${formData.message}
    `);
    
    window.open(`mailto:highlandssportsbar@gmail.com?subject=${subject}&body=${body}`, '_blank');
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prevState => ({
      ...prevState,
      [name]: value
    }));
  };

  if (step === 2) {
    return (
      <div className="careers-container">
        <h1 className="careers-title">Almost Done!</h1>
        
        <section className="careers-info">
          <h2>Next Steps</h2>
          <div className="instructions">
            <p>We've prepared an email with your application information. When you click "Send Application" below:</p>
            <ol>
              <li>Your default email client will open with your information pre-filled</li>
              <li>Please attach your resume and/or cover letter (PDF format) to the email</li>
              <li>Review the email contents and click send</li>
            </ol>
            <p className="note">Make sure to have your resume and/or cover letter ready in PDF format before proceeding.</p>
          </div>
          <form onSubmit={handleSubmit} className="careers-form">
            <button type="submit" className="submit-button">
              Send Application
            </button>
          </form>
        </section>
      </div>
    );
  }

  return (
    <div className="careers-container">
      <h1 className="careers-title">Join a growing team with a love for food</h1>
      
      <section className="careers-info">
        <h2>Why work with us?</h2>
        <p>We are always hiring A players who work hard, love helping others, and do great work. Fill out the 2 minute form below with your resume and a few sentences about you.</p>
      </section>

      <div className="location">
        <h2>Location</h2>
        <p>Highlands Sports Bar & Grill<br />644 Laurel Street suite C, San Carlos, CA 94070</p>
      </div>

      <section className="application-section">
        <h2>Application</h2>
        <form onSubmit={handleSubmit} className="careers-form">
          <div className="form-group">
            <label htmlFor="fullName">Full Name<span className="required">*</span></label>
            <input
              type="text"
              id="fullName"
              name="fullName"
              value={formData.fullName}
              onChange={handleChange}
              placeholder="Full name"
              required
            />
          </div>

          <div className="form-group">
            <label htmlFor="email">Email<span className="required">*</span></label>
            <input
              type="email"
              id="email"
              name="email"
              value={formData.email}
              onChange={handleChange}
              placeholder="Email"
              required
            />
          </div>

          <div className="form-group">
            <label htmlFor="phoneNumber">Phone Number<span className="required">*</span></label>
            <input
              type="tel"
              id="phoneNumber"
              name="phoneNumber"
              value={formData.phoneNumber}
              onChange={handleChange}
              placeholder="(555) 555-5555"
              required
            />
          </div>

          <div className="form-group">
            <label htmlFor="message">Anything to share as we consider your application?</label>
            <textarea
              id="message"
              name="message"
              value={formData.message}
              onChange={handleChange}
              rows="4"
              placeholder="Message"
            />
          </div>

          <div className="attachment-notice">
            <h3>Important Note About Resume/Cover Letter</h3>
            <p>On the next page, you'll be prompted to:</p>
            <ol>
              <li>Open your email client</li>
              <li>Attach your resume and/or cover letter (PDF format)</li>
              <li>Review and send your application</li>
            </ol>
            <p className="note">Please have your documents ready in PDF format before proceeding.</p>
          </div>

          <button type="submit" className="submit-button">
            Next →
          </button>
        </form>
      </section>
    </div>
  );
};

export default Careers; 